import { useEffectWithController } from '@carvana/merch-react-hooks';
import { isSuccess, isFailure } from '@carvana/merch-result';
import { useContext } from 'react';
import StaticContext from '~/context/common/StaticContext';
import { useUserLocation, useIsLoggedIn } from '~/context/common/UserContext';
import { useGetIsReturnUser } from '~/context/home/GlobalContext';
import RecentSearchesContext from '~/context/home/RecentSearchesContext';
import { fetchRecentSearches } from '~/services/home';
import { BrowserCookies } from '~/utilities';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetRecentSearches() {
  const {
    recentSearches: { setData, setLoaded, setLoading, setError }
  } = useContext(RecentSearchesContext);
  const { eventCorrelationId } = useContext(StaticContext);
  const isLoggedIn = useIsLoggedIn();
  const { zip } = useUserLocation();
  const isReturningUser = useGetIsReturnUser();

  useEffectWithController(
    controller => {
      const browserCookieId = BrowserCookies.get('BrowserCookieId');

      if (!browserCookieId || !zip || !isReturningUser) {
        setLoaded();

        return;
      }

      setLoading();

      fetchRecentSearches(
        {
          browserCookieId,
          correlationId: eventCorrelationId,
          count: 8,
          zip5: zip
        },
        isLoggedIn,
        controller
      )
        .then(result => {
          if (isSuccess(result)) {
            setData(result.content.recentSearches);

            return;
          }

          if (isFailure(result)) {
            setError(new Error(result.errorMessage));
          }

          setData([]);
        })
        .catch(
          generateErrorLogger(
            'Get user recent searches',
            {},
            { callback: setError, controller }
          )
        );
    },
    [
      eventCorrelationId,
      isLoggedIn,
      isReturningUser,
      setData,
      setError,
      setLoaded,
      setLoading,
      zip
    ]
  );
}
